import type { FeaturePreview } from '@onefootprint/request-types/dashboard';

type FeaturePreviewConfig = {
  /** What a user who never chose sees. Most previews start off. */
  defaultEnabled: boolean;
};

const FEATURE_PREVIEWS: Record<FeaturePreview, FeaturePreviewConfig> = {
  onboardings_strip: { defaultEnabled: true },
};

/** The Datadog RUM global context key that carries which experience the user sees. */
export const getFeaturePreviewContextKey = (preview: FeaturePreview) => `feature_preview_${preview}`;

export default FEATURE_PREVIEWS;
